/* Install layouts */
import DashboardLayout from './DashboardLayout.vue'
import DefaultLayout from './DefaultLayout.vue'
const installComponentLayouts = app => {
  app.component('default-layout', DefaultLayout)
  app.component('dashboard-layout', DashboardLayout)
}
export default installComponentLayouts
